type Value = string | number | boolean | undefined | null;
type MixObject = {
  [key: string]: boolean | Mix | undefined | null;
};
type MixArray = Array<Mix>;
type Mix = Value | MixObject | MixArray;

function toVal(mix: Mix): string {
  let k,
    y,
    str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if ((y = toVal(mix[k]))) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (!mix || mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }

  return str;
}

export function clsx(...args: Mix[]): string {
  let i = 0,
    tmp,
    x,
    str = '';

  while (i < arguments.length) {
    if ((tmp = arguments[i++])) {
      if ((x = toVal(tmp))) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}

export default clsx;
